import { render, staticRenderFns } from "./KimNPCComponent.vue?vue&type=template&id=04982d28&scoped=true"
import script from "./KimNPCComponent.vue?vue&type=script&lang=ts"
export * from "./KimNPCComponent.vue?vue&type=script&lang=ts"
import style0 from "./KimNPCComponent.vue?vue&type=style&index=0&id=04982d28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04982d28",
  null
  
)

export default component.exports